import axiosInstance from '../../../../../utils/axios';
import { JWTPayload, RegisterRequest } from './models';
import { LoginResponse } from './interfaces';
import { decodeJWT } from '../../utils/decodedJWT';
import { handleRegisterError } from './errors';
import { CustomApiResponse } from '../../../../../utils/apiResponse';
import { TokenResponse } from '../login/models';

export const registerUser = async (
  data: RegisterRequest,
): Promise<{ tokens: LoginResponse; user: JWTPayload }> => {
  try {
    const response = await axiosInstance.post<any>(
      `/users/register`,
      data,
    );

    // New API format: { status: 'success', data: { accessToken, refreshToken, permissionNames }, error: null }
    const apiResponse = response.data;
    const tokens = apiResponse.data as LoginResponse;

    const decoded = decodeJWT(tokens.accessToken);

    if (!decoded) {
      throw new Error('Failed to decode the JWT.');
    }

    return { tokens, user: decoded };
  } catch (error) {
    handleRegisterError(error);
    throw new Error('Registration failed due to an error');
  }
};

/**
 * Register a user by sending the accessToken and type to the backend.
 * POST {{host}}/api/users/register
 */
export const registerWithGoogle = async (
  accessToken: string,
  referredBy?: string,
): Promise<CustomApiResponse<TokenResponse>> => {
  const payload: Record<string, string> = { accessToken, type: 'guser' };
  if (referredBy) payload.referredBy = referredBy;

  const response = await axiosInstance.post<CustomApiResponse<TokenResponse>>(
    '/users/register',
    payload,
    {
      headers: {
        Authorization: '',
      },
    },
  );

  return response.data;
};

